/**
 * Free shipping progress bar — multi-currency hydration.
 *
 * Reads `window.Shopify.currency.rate` (injected by Dawn for Markets
 * multi-currency stores: shop_currency × rate = display_currency) and
 * updates the bar in the visitor's currency.
 */
(function () {
  function getRate() {
    var rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    return isFinite(rate) && rate > 0 ? rate : 1;
  }

  function hydrate(el) {
    var shopCurrency = el.dataset.shopCurrency;
    var displayCurrency = el.dataset.displayCurrency;
    if (!shopCurrency || !displayCurrency || shopCurrency === displayCurrency) return;

    var thresholdShopCents = parseInt(el.dataset.thresholdShopCents, 10);
    var cartTotalDisplayCents = parseInt(el.dataset.cartTotalDisplayCents, 10);
    if (!thresholdShopCents) return;

    var rate = getRate();
    var thresholdDisplayCents = Math.round(thresholdShopCents * rate);
    var cartCents = isNaN(cartTotalDisplayCents) ? 0 : cartTotalDisplayCents;
    var remainingCents = Math.max(0, thresholdDisplayCents - cartCents);
    var percent = Math.min(100, Math.round((cartCents / thresholdDisplayCents) * 100));

    var fill = el.querySelector('.progress-bar-fill');
    if (fill) fill.style.width = percent + '%';

    var msgEl = el.querySelector('.free-shipping-message');
    if (!msgEl) return;
    if (cartCents >= thresholdDisplayCents) {
      msgEl.innerHTML = "<strong>You've unlocked FREE UK SHIPPING</strong>";
    } else {
      var formatted;
      try {
        formatted = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: displayCurrency,
          maximumFractionDigits: 2,
        }).format(remainingCents / 100);
      } catch (e) {
        formatted = (remainingCents / 100).toFixed(2) + ' ' + displayCurrency;
      }
      msgEl.innerHTML =
        'Spend <span class="free-shipping-amount">' + formatted +
        '</span> more for <strong>FREE UK SHIPPING</strong>';
    }
  }

  function run() {
    document.querySelectorAll('#free-shipping-bar').forEach(hydrate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.id === 'free-shipping-bar') hydrate(node);
        else if (node.querySelector) {
          var inner = node.querySelector('#free-shipping-bar');
          if (inner) hydrate(inner);
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
